const ArchiveAdminPanel = () => {
  return (
    <div></div>
  );
};

export default ArchiveAdminPanel;
